import { z } from "zod/v4"
import { PredefinedAliasQualifierId } from "../id"
import { DocumentSnapshotLike } from "../firestore"
import { CreatedAt, UpdatedAt } from "./system"


export class PredefinedAliasQualifiers {

  public static readonly ALIAS_QUALIFIER_MIN_LENGTH = 1
  public static readonly ALIAS_QUALIFIER_MAX_LENGTH = 15 // Users.ALIAS_MAX_LENGTHの半分

  static toDocumentData(predefinedAliasQualifierDocument: PredefinedAliasQualifierDocument): object {
    return {
      ...predefinedAliasQualifierDocument,
      id: undefined,
    }
  }

  static fromDocumentSnapshot(doc: DocumentSnapshotLike | null): PredefinedAliasQualifierDocument | null {
    if (!doc) {
      return null
    }
    const data = doc.data()
    if (data === undefined) {
      return null
    }

    return {
      id: PredefinedAliasQualifierId(doc.id),
      value: data["value"],
      created_at: data["created_at"],
      updated_at: data["updated_at"],
    }
  }
}

export const PredefinedAliasQualifierValue = z.object({
  value: z.string().min(PredefinedAliasQualifiers.ALIAS_QUALIFIER_MIN_LENGTH).max(PredefinedAliasQualifiers.ALIAS_QUALIFIER_MAX_LENGTH).describe("二つ名の修飾語"),
})

export type PredefinedAliasQualifierValue = z.infer<typeof PredefinedAliasQualifierValue>

export const PredefinedAliasQualifierDocumentBody = z.intersection(
  PredefinedAliasQualifierValue,
  z.object({
    created_at: CreatedAt,
    updated_at: UpdatedAt
  })
)

export type PredefinedAliasQualifierDocumentBody = z.infer<typeof PredefinedAliasQualifierDocumentBody>

export type PredefinedAliasQualifierDocument = PredefinedAliasQualifierDocumentBody & {
  id: PredefinedAliasQualifierId,
}
